import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの免許証情報を取得する
 *
 * @param {Number} uid ユーザID
 * @returns {Response} レスポンスデータ
 */
export function getUserLicense (uid) {
  return request.get(`/users/${uid}/license`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
